<template>
    <NavigationMenu/>
    <Breadcrumbs/>
    <div class="mx-auto px-2 sm:px-6 lg:px-8">
        <FlashMessage class="mb-2"/>
        <slot/>
    </div>
</template>

<script>
import BreezeApplicationLogo from '@/Components/ApplicationLogo.vue'
import BreezeDropdown from '@/Components/Dropdown.vue'
import BreezeDropdownLink from '@/Components/DropdownLink.vue'
import BreezeNavLink from '@/Components/NavLink.vue'
import BreezeResponsiveNavLink from '@/Components/ResponsiveNavLink.vue'
import { Link } from '@inertiajs/vue3';
import NavigationMenu from "@/Partials/NavigationMenu.vue";
import SubMenu from "@/Partials/SubMenu.vue"
import FlashMessage from "@/Components/FlashMessage.vue";
import Breadcrumbs from "@/Components/Breadcrumbs.vue";
import ValidationErrors from "@/Components/ValidationErrors.vue";

export default {
    components: {
        ValidationErrors,
        Breadcrumbs,
        FlashMessage,
        NavigationMenu,
        SubMenu,
        BreezeApplicationLogo,
        BreezeDropdown,
        BreezeDropdownLink,
        BreezeNavLink,
        BreezeResponsiveNavLink,
        Link
    },

    data() {
        return {
            showingNavigationDropdown: false,
        }
    }
}
</script>
